import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { TimeUtils } from "@fidget/common/utils/timeUtils";
import classNames from "classnames";
import { upperFirst } from "lodash";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "../../models";
import styles from "./calendarNavigationBar.css";

export interface Props {
  weekly: boolean;
  showTodayButton: boolean;
}

export const CalendarNavigationBar = observer(({ weekly, showTodayButton }: Props) => {
  const { calendarStore } = useStore();
  const displayedDay = calendarStore.displayedDay;
  const days = TimeUtils.datesRange(displayedDay, weekly);

  return (
    <div className={classNames(styles["calendar-navigation-bar"], { [styles.weekly]: weekly })}>
      <div className={styles.title}>
        {weekly ? (
          <L10n id={"calendar.title"} />
        ) : (
          upperFirst(intl.formatRelativeDays(displayedDay))
        )}
      </div>
      <div className={styles.navigation}>
        <div
          className={
            showTodayButton
              ? styles["today-button-container-visible"]
              : styles["today-button-container-hidden"]
          }
        >
          <AgentButton
            onClick={() => calendarStore.navigateTo(0)}
            buttonStyle={"outlined primary"}
            small
          >
            <L10n id={"date.today"} />
          </AgentButton>
        </div>
        <AgentButton
          onClick={() => calendarStore.navigateTo(weekly ? -7 : -1)}
          buttonStyle={"outlined primary"}
          small
          icon={`icon-arrow ${styles.rotated}`}
        />
        {weekly && (
          <div className={styles["current-dates-span"]}>{TimeUtils.formatDatesRange(days)}</div>
        )}
        <AgentButton
          onClick={() => calendarStore.navigateTo(weekly ? 7 : 1)}
          buttonStyle={"outlined primary"}
          small
          icon={`icon-arrow`}
        />
      </div>
      {weekly && (
        <AgentButton onClick={() => calendarStore.createSearchPopup()} icon={"icon-plus"} small />
      )}
    </div>
  );
});
